import React from 'react';
import { MessagesSquare } from 'lucide-react';
import CaseActivityItem from './CaseActivityItem';

// The unified chronological feed. Emails, texts, web form submissions, internal
// notes and system events all live in CaseActivity, so the stream is a single
// ordered list rather than a merge of separate sources.
export default function CaseActivityStream({ activities = [] }) {
  const sorted = [...activities].sort(
    (a, b) => new Date(b.occurred_at).getTime() - new Date(a.occurred_at).getTime()
  );

  return (
    <div className="border border-white/5 bg-[#0d0d0f]">
      <div className="flex items-center justify-between px-5 py-3.5 border-b border-white/5">
        <div className="flex items-center gap-2">
          <MessagesSquare className="w-4 h-4 text-primary" />
          <p className="text-white text-xs font-bold tracking-widest">ACTIVITY</p>
        </div>
        <span className="text-white/30 text-[10px] font-bold tracking-wider">
          {activities.length} ENTRIES
        </span>
      </div>

      {sorted.length === 0 ? (
        <p className="text-white/30 text-xs py-16 text-center">No activity on this case yet.</p>
      ) : (
        <div className="p-4 space-y-3 max-h-[62vh] overflow-y-auto">
          {sorted.map((a) => (
            <CaseActivityItem key={a.id} activity={a} />
          ))}
        </div>
      )}
    </div>
  );
}